interface Category {
  title: string;
  url: string;
  href: string;
}

export const useCategoryChunk = (data: Category[], parent: string, rows = 1): { title: string; url: string; href: string }[][] => {
  const filteredCategories = data
    .map((item) => ({
      title: item.title,
      url: item.url,
      href: item.href,
    }));

  const result: { title: string; url: string; href: string }[][] = [];
  for (let i = 0; i < filteredCategories.length; i += rows) {
    result.push(filteredCategories.slice(i, i + rows));
  }
  return result;
};
